//*react- recursos
import React, { useState, useRef } from "react";
import JoditEditor from "jodit-react";

//*install
//npm install --save sweetalert2
//npm i jodit-react

//*css
import "./style.css";
import "jodit/build/jodit.min.css";

/* eslint-disable @typescript-eslint/no-unused-expressions */

import validarEmail2 from "./validaEmails"; //valida correo electonico
import espaciobco from "./validaEspBlanco"; //quita los espacios en blanco para validar

import swal2 from "sweetalert2"; //npm install --save sweetalert2

const GeneraCorreo1 = () => {
  const [value, setValue] = React.useState<string>();
  //objeto
  const [datos, setDatos] = React.useState({
    para: "",
    cc: "",
    asunto: "",
  });
  let countpp = 0;
  let countcc = 0;
  let amensajepp: any = [];
  let mensajepp;
  let amensajecc: any = [];
  let mensajecc;
  //datos a enviar del mensaje
  const handleInputChange = (event: any) => {
    /* console.log("name:", event.target.name);
    console.log("value:", event.target.value); */
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    });
  };
  //validación y datos a enviar
  const enviarDatos = (event: any) => {
    event.preventDefault();
    let datospp = datos.para;
    let datoscc = datos.cc;
    mensajepp = datospp.trim();
    mensajecc = datoscc.trim();
    amensajepp = mensajepp.split(";");
    amensajecc = mensajecc.split(";");

    countpp = amensajepp.length;
    countcc = amensajecc.length;

    //valida correos unicos
    let trimmed = espaciobco(amensajepp);
    let trimmed1 = espaciobco(amensajecc);

    //correos unicos
    const amensajepp1 = trimmed.filter((valor: any, indice: any) => {
      return trimmed.indexOf(valor) === indice;
    });
    const amensajecc1 = trimmed1.filter((valor: any, indice: any) => {
      return trimmed1.indexOf(valor) === indice;
    });

    // console.log("unicos...pp.", amensajepp1); // [1, 2, 3, 4, 5]
    // console.log("unicos...cc.", amensajecc1); // [1, 2, 3, 4, 5]

    let result; //devuelve true o false de la validacion del correo
    //obtiene td para pintar el error
    const ppPara = document.getElementById(
      "ppError"
    ) as HTMLButtonElement | null;
    const ccCC = document.getElementById("ccError") as HTMLButtonElement | null;

    //rutina para PP
    for (let i = 0; i < countpp; i++) {
      let valida = amensajepp[i].trim();
      if (valida !== "") {
        result = validarEmail2(valida);
      } else {
        //si hay campo vacio al final, quita el ultimo
        amensajepp.splice(amensajepp.length - 1);
      }
      if (!result) {
        ppPara != null ? (ppPara.style.display = "contents") : "";
        //si hay correos incorrectos
        return; //con el primero que no sea valido pinta el rojo
      } else {
        ppPara != null ? (ppPara.style.display = "none") : "";
      }
    }
    //rutina para CC
    for (let i = 0; i < countcc; i++) {
      let valida = amensajecc[i].trim();
      if (valida !== "") {
        result = validarEmail2(valida);
      } else {
        amensajecc.splice(amensajecc.length - 1);
      }
      if (!result) {
        ccCC != null ? (ccCC.style.display = "contents") : "";
        return; //con el primero que no sea valido pinta el rojo
      } else {
        ccCC != null ? (ccCC.style.display = "none") : "";
      }
    }
    console.log("result.....", result);

    //si las validaciones de correo estan bien
    if (result) {
      ccCC != null ? (ccCC.style.display = "none") : "";
      ppPara != null ? (ppPara.style.display = "none") : "";
      if (datos.asunto === "") {
        //alert
        swal2
          .fire({
            title: "Asunto Vacío. Desea continuar?",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            denyButtonText: `Cancelar`,
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // confirm button pressed
              if (content === "") {
                swal2.fire(
                  "El Mensaje no puede ir vacío...Verifique!",
                  "",
                  "error"
                );
              } else {
                const DatosEnviar = {
                  para: amensajepp1.concat(), //UNICOS
                  cc: amensajecc1.concat(), //UNICOS
                  asunto: datos.asunto,
                  mensaje: content,
                };
                console.log("DatosEnviar....", DatosEnviar);
                swal2.fire("datos a enviar" + JSON.stringify(DatosEnviar));
              }
            } else if (result.isDismissed) {
              // deny button pressed
              console.log("deny");
            }
          });
      } else {
        if (content === "") {
          swal2.fire("El Mensaje no puede ir vacío...Verifique!", "", "error");
        } else {
          //console.log("enviando datos..." + datos.para + " " + datos.cc);
          const DatosEnviar = {
            para: amensajepp1.concat(), //UNICOS
            cc: amensajecc1.concat(), //UNICOS
            asunto: datos.asunto,
            mensaje: content,
          };
          console.log("DatosEnviar....", DatosEnviar);
          swal2.fire("datos a enviar" + JSON.stringify(DatosEnviar));
        }
      }
    }
  };

  // const editor = useRef(null);
  const [content, setContent] = useState("");

  const config = {
    //readonly: false, // all options from https://xdsoft.net/jodit/doc/
    placeholder: "Mensaje ...",
    link: {
      //quita opciones del boton link
      modeClassName: false,
      openInNewTabCheckbox: false,
      noFollowCheckbox: false,
    },
    buttons: [
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "font",
      "|",
      "ul",
      "ol",
      "|",
      "center",
      "left",
      "right",
      "justify",
      "|",
      "link",
      "image",
    ],
    activeButtonsInReadOnly: ["source", "fullsize", "print", "about", "dots"],
    //toolbarButtonSize: "middle",
    theme: "default",
    saveModeInCookie: false,
    //direction: "left",
    textIcons: false,
    tabIndex: -1,
    toolbar: true,
    showXPathInStatusbar: false,
    showCharsCounter: false,
    showWordsCounter: false,
    toolbarAdaptive: false,
    language: "es",
    debugLanguage: false,
  };

  //const { contents, getValue } = props;
  const handleChange = (newContent: string) => {
    setContent(newContent);
  };
  return (
    <>
      <div className="background-color-white">
        <form className="cf" onSubmit={enviarDatos}>
          <div className="container-fluid">
            <table>
              <tr>
                <td className="ancho5" rowSpan={4}>
                  <input
                    name="submit"
                    type="submit"
                    id="input-submit"
                    value="Enviar"
                    className="inputenv"
                  />
                </td>
                <td className="ancho10">Para</td>
                <td className="ancho80">
                  <input
                    type="text"
                    placeholder=""
                    name="para"
                    onChange={handleInputChange}
                    className="inputfor"
                  />
                </td>
                <br />
              </tr>
              <tr id="ppError" style={{ display: "none" }}>
                <td></td>
                <td className="error" colSpan={3}>
                  Error en correo, separar con ;
                </td>
              </tr>
              <tr>
                <td className="ancho10">CC</td>
                <td className="ancho60">
                  <input
                    type="text"
                    placeholder=""
                    onChange={handleInputChange}
                    name="cc"
                    className="inputfor"
                  />
                </td>
              </tr>
              <tr id="ccError" style={{ display: "none" }}>
                <td></td>
                <td className="error" colSpan={3}>
                  Error en correo, separar con ;
                </td>
              </tr>
              <tr>
                <td className="ancho10">Asunto</td>
                <td className="ancho10" colSpan={3}>
                  <input
                    type="text"
                    placeholder=""
                    onChange={handleInputChange}
                    name="asunto"
                    className="inputfor"
                  />
                </td>
              </tr>
            </table>
          </div>
          <br /> <br />
          <div className="row">
            {React.useMemo(() => {
              return (
                <JoditEditor
                  value={content}
                  config={config}
                  onChange={handleChange}
                />
              );
            }, [])}
          </div>{" "}
        </form>
        <br />
        <br />
        Datos_Para:{datos.para}
        <br />
        Datos_cc:{datos.cc}
        <br />
        Asunto:{datos.asunto}
        Contenido{content}
      </div>
    </>
  );
};

export default GeneraCorreo1;
